/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  CreateMarketMakerOptions,
  CreateMarketMakerResponses,
} from '../types/CreateMarketMaker'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Admin only. All percentages are fractions in [0,1].
 * @summary Create a market maker
 * {@link /v1/market-makers}
 */
export function createMarketMaker<ThrowOnError extends boolean = true>(
  options: Options<CreateMarketMakerOptions, ThrowOnError>,
): Unwrappable<RequestResult<CreateMarketMakerResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/v1/market-makers',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<CreateMarketMakerResponses, ThrowOnError>>,
  )
}
